import { useQuery } from '@tanstack/react-query';
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getErrorCode, getErrorStatusCode } from "../../../../api/api-response";
import { RestEndpoints } from "../../../../api/endpoints";
import { PomTakeBackSystemConverter } from "../../../domain/converter/pom-takeback-system.converter";
import { IPomProductTakeBackSystem } from "../../../domain/models/takeback-system";
import { IPomProductTakeBackSystemListModel } from "../../models/products/pom-product-take-back-system.model";
import getInstance from "../../../../utils/rest";
import { PomQueryKeys } from "../../pom-query-keys";

const getTakeBackSystems = async (): Promise<IPomProductTakeBackSystem[]> => {
  const response = await getInstance().get<IPomProductTakeBackSystemListModel>(RestEndpoints.PomProductTakeBackSystems);
  return response.data.items.map(PomTakeBackSystemConverter.toDomain);
};

export const useGetTakeBackSystemsQuery = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const query = useQuery({
    queryKey: [PomQueryKeys.GetTakeBackSystems],
    queryFn: () => getTakeBackSystems()
  });

  useEffect(() => {
    if (query.error) {
      const errorMsg = getErrorCode(query.error);
      const errorCode = getErrorStatusCode(query.error);
      enqueueSnackbar(t("general.error_occurred", { errorCode, errorMsg }), { variant: "error" });
    }
  }, [query.error, enqueueSnackbar, t]);

  return query;
};
